export default __webpack_public_path__ + "static/media/NoSearchResult.739ea021.svg";